import * as R from "ramda";
import { DATAQUERY_DIMENSIONS_SEPARATOR, ALL_IDENTIFIER } from "./constants/url.mjs";
const getUrlDataquery = (dataquery) => R.pipe(
  R.when(R.isNil, R.always("")),
  R.when(
    R.pipe(
      R.replace(new RegExp(`\\${DATAQUERY_DIMENSIONS_SEPARATOR}`, "g"), ""),
      R.isEmpty
    ),
    R.always(ALL_IDENTIFIER)
  )
)(dataquery);
export {
  getUrlDataquery
};
